interface ConfidenceBadgeProps {
  badge: "high" | "low";
}

export function ConfidenceBadge({ badge }: ConfidenceBadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ${
        badge === "high" ? "bg-emerald-100 text-emerald-800" : "bg-amber-100 text-amber-800"
      }`}
    >
      {badge === "high" ? "High Confidence" : "Low Confidence (N<100)"}
    </span>
  );
}
